"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxActions = require("redux-actions");

var _httpActions = require("../actions/http-actions");

var _util = require("./util");

var _disclosureActions = require("../actions/disclosure-actions");

var _handleActions;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var initialState = {
  disclosuresByUuid: {// '9f3c7e7e-7496-11e8-adc0-fa7ae01bbebc': {
    //   uuid: '9f3c7e7e-7496-11e8-adc0-fa7ae01bbebc',
    //   applicationUuid: 'a6d3c3d4-369a-11e8-b467-0ed5f89f718b',
    //   disclosures: []
    // }
  },
  loading: false,
  error: ''
};
exports.initialState = initialState;
var DEFAULT_DOCUMENT_VALUE = 99;
var DOCUMENT_VALUE = {
  AUTOPAYAGREEMENT: 1,
  COMPLIANCEAGREEMENT: 2,
  CREDITDISCLOSURE: 3,
  HELOCMORTGAGEAGREEMENT: 100 // bigger than default so its always after state loan docs

};

function merge(state, action) {
  var uuid = action.payload.uuid;
  var disclosure = state.disclosuresByUuid[uuid] || {};
  return _objectSpread(_objectSpread({}, state), {}, {
    disclosuresByUuid: _objectSpread(_objectSpread({}, state.disclosuresByUuid), {}, (0, _defineProperty2.default)({}, uuid, _objectSpread(_objectSpread({}, disclosure), {}, {
      uuid: uuid,
      applicationUuid: action.payload.applicationUuid,
      disclosures: (0, _util.mergeList)(disclosure.disclosures, action.payload.disclosures).sort(function (a, b) {
        if (a.type > b.type) {
          return 1;
        } else if (a.type < b.type) {
          return -1;
        }

        var aValue = DOCUMENT_VALUE[a.document.type] || DEFAULT_DOCUMENT_VALUE;
        var bValue = DOCUMENT_VALUE[b.document.type] || DEFAULT_DOCUMENT_VALUE;
        return aValue - bValue;
      })
    }))),
    loading: false,
    error: ''
  });
}

var reducer = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, "".concat(_disclosureActions.GET_APPLICATION_DISCLOSURES, "_").concat(_httpActions.REQUEST), function _() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: true
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_disclosureActions.GET_APPLICATION_DISCLOSURES, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  return merge(state, action);
}), (0, _defineProperty2.default)(_handleActions, "".concat(_disclosureActions.ESIGN_DISCLOSURE, "_").concat(_httpActions.REQUEST), function _() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return _objectSpread(_objectSpread({}, state), {}, {
    error: ''
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_disclosureActions.ESIGN_DISCLOSURE, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  // TODO: investigate failure use cases
  if (action.payload.msg) {
    return _objectSpread(_objectSpread({}, state), {}, {
      error: action.payload.msg
    });
  }

  var disclosure = Object.values(state.disclosuresByUuid).find(function (dl) {
    return dl.disclosures.filter(function (d) {
      return d.document.uuid === action.payload.referenceDocumentUuid;
    }).length > 0;
  });

  if (!disclosure) {
    return _objectSpread(_objectSpread({}, state), {}, {
      error: "No disclosure with document ".concat(action.payload.documentUuid, " found")
    });
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    disclosuresByUuid: _objectSpread(_objectSpread({}, state.disclosuresByUuid), {}, (0, _defineProperty2.default)({}, disclosure.uuid, _objectSpread(_objectSpread({}, disclosure), {}, {
      disclosures: disclosure.disclosures.map(function (d) {
        if (d.document.uuid === action.payload.referenceDocumentUuid) {
          return _objectSpread(_objectSpread({}, d), {}, {
            hasEsignature: d.hasEsignature || false || action.payload.succeeded
          });
        }

        return d;
      })
    })))
  });
}), _handleActions), initialState);
var _default = reducer;
exports.default = _default;